import { useEffect } from 'react'
import { usePage } from '@inertiajs/react'
import { toast } from 'sonner'

// Keyed on the flash object, not the text, so a second identical refusal still shows.
export function useFlashAlert() {
  const { flash } = usePage<{ flash?: { alert?: string } }>().props

  useEffect(() => {
    if (flash?.alert) toast.error(flash.alert)
  }, [flash])
}
